class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Closing a native <details> removes its content from the render tree the instant the
    // `open` attribute is gone, so the opening fade-in (animateMenuOpen) had no closing
    // counterpart — it snapped shut. Intercept a close-click on the summary so it fades out
    // first, same as onFocusOut below routes through close() for every other close path.
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', (event) => {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        event.preventDefault();
        this.close();
      }
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open') || this._closing) return;
    this._closing = true;
    const details = this.mainDetailsToggle;
    const summary = details.querySelector('summary');
    const content = this.content;
    summary.setAttribute('aria-expanded', false);

    const finish = () => {
      if (!this._closing) return;
      this._closing = false;
      details.removeAttribute('open');
      content.removeEventListener('transitionend', finish);
      content.style.removeProperty('transition');
      content.style.removeProperty('opacity');
      content.style.removeProperty('transform');
    };

    content.style.transition = 'opacity 180ms ease, transform 180ms ease';
    requestAnimationFrame(() => {
      content.style.opacity = '0';
      content.style.transform = 'translateY(-1.5rem)';
    });
    content.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 220); // safety fallback if transitionend never fires
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
